export const iconFontAwesomeUsersPeoplePersonChalkboard = (
	<i className="fa-solid fa-person-chalkboard"></i>
);
